import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllManutencaoEquipObraUseCase } from "../../../presentation/useCases/read/get_all_manutencao_equip_obra_use_case";
import { ManutencaoEquipObraLista } from "../../models/manutencao_equip_obra_lista";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllObrasmaquinasequipamentosUseCase
 */

export class GetAllManutencaoEquipObraUseCase
  extends BasePaginatedUseCase<ManutencaoEquipObraLista>
  implements IGetAllManutencaoEquipObraUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async execute(
    idObra: number,
    page: number | null,
    rowsPerPage: number | null
  ): Promise<void> {
    const response = await this.repository.getAllManutencaoEquipObra(idObra, page, rowsPerPage);

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }

}

